import { render, staticRenderFns } from "./ProfileTags.vue?vue&type=template&id=4eded2fd"
import script from "./ProfileTags.vue?vue&type=script&lang=js"
export * from "./ProfileTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/skade-pwa/components/ui/atom/Img.vue').default})
